export const authRouteNames = [
  'loginWithEmail', 'signup', 'signupWithEmail', 'login',
  'forgotPassword', 'forgotPasswordSuccess',
  'verifyEmail', 'confirmEmployeeType',
  'resetPassword', 'resetPasswordSuccess',
]
